import WidgetUI from "./WidgetUI";

export default {
    data: () => ({
        status: {
            loading: true,
            ready: false,
            error: null,
        },
        baseUrl: "https://api.shadow-metrics.com"
    }),
    mixins: [WidgetUI],
    methods: {
        stylize(widgetName, style) {
            const widget = document.querySelector(widgetName);

            if (widget)
                widget.setAttribute("style", style);
        },
        async api(action, payload) {
            const url = `${this.baseUrl}/products/data/action?api=${this.apiKey}`;
            const data = {
                productId: this.productId,
                action: action,
                payload: payload
            };
            
            try {
                const resp = await fetch(url, {
                    method: 'POST',
                    mode: 'cors',
                    cache: 'no-cache',
                    credentials: 'same-origin',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    redirect: 'follow',
                    referrerPolicy: 'no-referrer',
                    body: JSON.stringify(data)
                });

                if (resp.status !== 200)
                    return { status: "api.error", message: "API Error" };

                return await resp.json();
            } catch {
                return { status: "api.error", message: "API Error" };
            }
        }
    }
};